import { type ReactNode, useEffect, useRef } from 'react';
import { Icon } from './Icon.tsx';

/** Accessible modal built on <dialog>. Closes on Esc and backdrop click. */
export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'md',
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className={`modal modal-${size}`}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
    >
      {open && (
        <div className='modal-inner'>
          <header className='modal-head'>
            <h2>{title}</h2>
            <button type='button' className='icon-btn' onClick={onClose} aria-label='बंद करा'>
              <Icon name='close' />
            </button>
          </header>
          <div className='modal-body'>{children}</div>
          {footer && <footer className='modal-foot'>{footer}</footer>}
        </div>
      )}
    </dialog>
  );
}
